// extracted by css-extract-rspack-plugin
export default {"dataDescription":"ttC1TeoiQhYVjrhq__dataDescription___"};